import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'simple-icons-ansible',
    template: `<svg class="simple-icons {{ className }}" [style.width]="size" [style.height]="size" [style.fill]="color" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>Ansible icon</title><path d="M10.617 11.473l4.686 3.695-3.102-7.662zM12 0C5.371 0 0 5.371 0 12s5.371 12 12 12 12-5.371 12-12S18.629 0 12 0zm5.797 17.305c-.011.471-.403.842-.875.83-.236 0-.416-.09-.664-.293l-6.19-5-2.079 5.203H6.191L11.438 5.44c.124-.314.427-.52.764-.506.326-.014.63.189.742.506l4.774 11.494c.045.111.08.234.08.348-.001.009-.001.009-.001.023z"/></svg>`,
    styles: []
})
export class SimpleIconsAnsibleComponent implements OnInit {
    @Input() size: string = '100%';
    @Input() color: string = '#EE0000';
    @Input() className: string = 'simple-icons-ansible'
    constructor() {}
    ngOnInit(): void {}
}
